import {StandingsAssetsRequestParams} from "./standings-assets.request-params";
import {THEME} from "../../../../core/app/consts";

export class StandingsLiveListAssetsRequestParams extends StandingsAssetsRequestParams {
  constructor(width: Number, height: Number) {
    super(width, height);

    this.resourceName = this.resourceName + '/List_Live';
  }

  get pathPostfix(): String {
    return super.pathPostfix + (this.theme === THEME.DARK ? `_dark` : '_light');
  }
}
